<template>
    <div>
        <h2 class="text-center p-3">รายละเอียดลูกหนี้</h2>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="m-auto">
                <form class="form-inline my-2 my-lg-0">
                    <!-- Search By Date Range -->
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    <multiselect
                        v-if="canViewAccounting"
                        v-model="search.sale"
                        class="form-control select"
                        @input="getCustomerFromSale"
                        :options="OptionSeller"
                        :customLabel="customLabel"
                        :show-labels="false"
                        placeholder="กรุณาเลือกเซลล์"
                        track-by="sale_id">
                    </multiselect>
                    <multiselect
                        class="form-control select"
                        v-model="search.customer"
                        :options="optionCustomer"
                        :show-labels="false"
                        track-by="customer_id"
                        :customLabel="customerLabel"
                        placeholder="กรุณาเลือกลูกค้า">
                    </multiselect>
                    <button @click="searchReceivable"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;

                </form>
            </div>
        </nav>
        <div class="row">
            <div class="col col-md-6 p-2">
            </div>
            <div class="col col-md-6 p-2 text-right">
                <button type="button"
                        @click="printCustomerBilling"
                        :disabled="diableprint"
                        class="btn btn-primary">
                    พิมพ์รายละเอียดลูกหนี้
                </button>
                &nbsp;&nbsp;
                <button class="btn btn-primary"
                        style="margin-right: 25px"
                        v-if="canSaleOrdersAllView"
                        :disabled="!activeOrderCount"
                        @click="showBillingModal">
                    <icon name="plus"></icon>
                    สร้างใบวางบิล
                </button>

                <button @click="viewreport"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    <icon name="print"></icon>
                    รายงานเก่าเก็บ
                </button>
                &nbsp
            </div>
        </div>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th rowspan="2" scope="col" v-if="canSaleOrdersAllView">
                        <input type="checkbox" v-model="selectAll" v-if="search.sale && this.select_all_chk"/>
                    </th>
                    <th rowspan="2" scope="col">บิล</th>
                    <th rowspan="2" scope="col">เครดิตเกิน</th>
                    <th rowspan="2" scope="col">ใบวางบิล</th>
                    <th rowspan="2" scope="col">วันที่บิล</th>
                    <th rowspan="2" scope="col">กำหนดชำระ</th>
                    <th rowspan="2" scope="col">จำนวนเงิน</th>
                    <th rowspan="2" scope="col">ในกำหนด</th>
                    <th colspan="2" scope="col">เกินกำหนด</th>
                </tr>
                <tr>
                    <th scope="col">1-30</th>
                    <th scope="col">มากกว่า 30</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(customer, index) in receivables">
                    <template v-if="customer.invoices.length > 0">
                        <tr>
                            <td>
                            </td>
                            <td class="text-left" colspan="9">
                                {{ customer.customer_id }} {{
                                    customer.store_name ? customer.store_name : customer.name
                                }} {{ customer.credit_note ? '(' + customer.credit_note + ')' : '' }}
                            </td>
                        </tr>

                        <tr v-for="invoice in customer.invoices">
                            <td v-if="canSaleOrdersAllView">
                                <template v-if="!invoice.billing_id">
                                    <input type="checkbox" v-model="checkbox_id"
                                           :value="invoice.id">
                                    <!--                                        <input type="checkbox" v-model="checkbox_id"-->
                                    <!--                                               :value="data.id"/>-->
                                </template>
                            </td>
                            <td>{{ invoice.invoice_id }}</td>
                            <td>{{ invoice.credit ? invoice.credit : '' }}</td>
                            <td>
                                {{ invoice.billing_number }}
                            </td>
                            <td>{{ invoice.date | moment("DD/MM/YYYY") }}</td>
                            <td>{{ invoice.due_date | moment("DD/MM/YYYY") }}</td>
                            <td>{{ invoice.remaining_payoff | currency }}</td>
                            <td>
                                <template v-if="invoice.due_date1">
                                    {{ invoice.due_date1 | currency }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </td>
                            <td>
                                <template v-if="invoice.due_date2">
                                    {{ invoice.due_date2 | currency }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </td>
                            <td>
                                <template v-if="invoice.due_date3">
                                    {{ invoice.due_date3 | currency }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </td>
                        </tr>
                    </template>
                    <tr v-if="customer.sum_total">
                        <td></td>
                        <td colspan="5"><b>รวม</b></td>
                        <td colspan="4"><b>{{ customer.sum_total | currency }} บาท</b></td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div>
            <b-modal hide-header hide-footer ref="loading" no-close-on-backdrop no-close-on-esc>
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
            </b-modal>
            <b-modal size="lg" hide-header hide-footer ref="billing_modal">
                <div style="text-align: center;">
                    <billing-modal @submit="submitBillingModal">
                    </billing-modal>
                </div>
            </b-modal>
            <b-modal size="lg" hide-header hide-footer ref="payment_modal">
                <payment-modal @submit="submitPaymentModal">
                </payment-modal>
            </b-modal>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getReceivablesPage">
        </vue-pagination>
        <!--        <pre class="alert-danger">{{array}}</pre>-->
        <!--        <pre class="alert-danger">{{receivables}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import moment from "moment"
import Multiselect from "vue-multiselect"
import DatePicker from 'vue2-datepicker'
import Modal from "bootstrap-vue/es/components/modal/modal"
import BillingModal from "./BillingModal"
import PaymentModal from "./PaymentModal"
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import {canSaleOrdersAllView, canSaleView, canViewAccounting,} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    components: {
        Loading,
        VuePagination,
        Multiselect,
        DatePicker,
        Modal,
        BillingModal,
        PaymentModal
    },
    name: "receivables",
    props: ["sellerId"],
    data() {
        return {
            array: '',
            msg: '',
            status_loading: '',
            select_all_chk: false,
            optionCustomer: [],
            checkbox_id: [],
            activeCount: 0,
            receivables_checkbox_all: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            diableprint: true,
        }
    },
    created() {
        this.$store.dispatch("Receivable/clearSearch");
        this.$store.dispatch("Seller/get");
        this.$store.dispatch("Receivable/setCheckbox", []);
        // this.getReceivable();
        // this.getCustomerFromSale();
        // this.firstLoad();
    },
    mounted() {
        this.getCustomerFromSale();
        this.getReceivable();
        // this.firstLoad();
    },
    computed: {
        canSaleView,
        canViewAccounting,
        canSaleOrdersAllView,
        ...mapState({
            receivables: state => {
                return state.Receivable.receivables
            },
            receivables_all: state => {
                return state.Receivable.receivables_all
            },
            seller: state => {
                return state.Seller.replace_data
            },
            billing: state => {
                return state.Billing.create_billing;
            },
            search: state => {
                return state.Receivable.search
            },
            OptionSeller: state => {
                return state.Seller.data;
            },
            user: state => {
                return state.Auth.user
            },
            dataPaginate: state => {
                return state.Receivable.dataPaginate
            }
        }),
        selectAll: {
            get: function () {
                return this.receivables_checkbox_all ? this.receivables_checkbox_all : false;
            },
            set: function (value) {
                this.activeCount = 0;
                this.receivables_checkbox_all = false;
                if (value) {
                    this.activeCount = this.activeOrderCount;
                    this.receivables_checkbox_all = true;
                    this.checkbox_id = [];
                    this.getAll();
                    // if(this.receivables.length>0){
                    //     this.receivables.forEach(receivable=>{
                    //         receivable.invoices.forEach(invoice=>{
                    //             if(!invoice.billing_id){
                    //                 this.checkbox_id.push(invoice.id);
                    //                 invoice.active = true;
                    //             }
                    //         })
                    //     })
                    // }
                } else {
                    // if(this.receivables.length>0){
                    //     this.receivables.forEach(receivable=>{
                    //         receivable.invoices.forEach(invoice=>{
                    //             invoice.active = false;
                    //         })
                    //     })
                    // }
                    this.checkbox_id = [];
                    this.hideLoadingModal();
                }
            }
        },
        activeOrderCount() {
            this.activeCount = 0;
            if (this.receivables && this.receivables.length > 0) {
                this.receivables.forEach(receivable => {
                    const invoiceFilter = receivable.invoices.filter(invoice => this.checkbox_id.includes(invoice.id));
                    this.activeCount += invoiceFilter.length
                })
            }
            return this.activeCount
        },
        activeOrder() {
            if (this.activeOrderCount === 1) {
                this.receivables.forEach(receivable => {
                    const invoiceActive = receivable.invoices
                        .find(invoice => invoice.active);
                    if (invoiceActive) {
                        return invoiceActive
                    }
                })
            }
            return false
        },
    },
    methods: {
        getReceivable() {
            this.msg = 'กำลังโหลดข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            if (this.canSaleOrdersAllView) {
                this.search.sale_id = '';
            } else {
                this.search.sale_id = this.user.id;
            }
            this.$store.dispatch("Receivable/setReceivables", {
                page: 1,
                search: this.search
            }).then(() => {
                this.hideLoadingModal();
            });
        },
        customerLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        customLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        printCustomerBilling() {
            this.diableprint = true;
            const page = 1;

            if (this.search.date.length > 0 && this.search.date[0]) {
                this.search.start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                this.search.end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.start_date = ""
                this.search.end_date = ""
            }
            window.open(domain + '/customer-billing-pdf?page=' + page +
                "&start_date=" + this.search.start_date +
                "&end_date=" + this.search.end_date +
                "&customer_id=" + this.search.customer_id +
                "&user=" + this.user.name +
                "&sale_id=" + this.search.sale_id, '_blank')
            this.diableprint = false;
        },
        firstLoad() {
            this.$store.dispatch("Receivable/firstLoad");
        },
        getAll() {
            let seller_id = '';
            if (this.canViewAccounting) { //account , superAdmin
                if (this.search.sale) {
                    seller_id = this.search.sale.id
                }
            } else { //sale
                seller_id = this.user.id;
            }
            if (this.search.customer) {
                this.search.customer_id = this.search.customer.id
            } else {
                this.search.customer_id = ""
            }
            this.search.sale_id = seller_id;
            this.search.action = 'all';
            this.$store.dispatch("Receivable/getAll", {
                page: 1,
                search: this.search
            }).then(res => {
                this.checkbox_id = [];
                res.forEach((receivable, i) => {
                    receivable.invoices.forEach(invoice => {
                        if (!invoice.billing_id) {
                            this.checkbox_id.push(invoice.id);
                        }
                    })
                })
                this.$store.dispatch("Receivable/setCheckbox", this.checkbox_id).then(() => {
                    this.hideLoadingModal();
                });
            });
        },
        searchReceivable() {
            this.msg = 'กำลังโหลดข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.receivables_checkbox_all = false;
            //TODO เช็ค select all
            this.select_all_chk = true;
            let seller_id = '';
            if (this.canViewAccounting) {
                if (this.search.sale) {
                    seller_id = this.search.sale.id
                }
            } else {
                seller_id = this.user.id;
            }
            if (this.search.customer) {
                this.search.customer_id = this.search.customer.id
            } else {
                this.search.customer_id = ""
            }
            this.search.sale_id = seller_id;
            this.search.action = 'search';
            this.$store.dispatch("Receivable/setReceivables", {
                page: 1,
                search: this.search
            }).then(() => {
                if (this.search.date) {
                    this.selectAll = true;
                } else {
                    this.hideLoadingModal();
                }
            });
            this.diableprint = false;
        },
        showBillingModal() {
            // //console.log(this.selectAll)
            this.$store.dispatch("Receivable/setCheckbox", this.checkbox_id);
            this.$refs.billing_modal.show();
        },
        viewreport() {
            window.open(`${domain}/tableau/reportOldKeep`);
        },
        hideBillingModal() {
            this.$refs.billing_modal.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        submitBillingModal(submitData) {
            this.hideBillingModal();
            this.select_all_chk = false;
            if (submitData) {
                let receivables = [];
                /*update to billing*/
                this.msg = 'กำลังบันทึกข้อมูล กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.receivables_all.forEach(receivable => {
                    const invoiceActives = receivable.invoices.filter(invoice => this.checkbox_id.includes(invoice.id))
                    if (invoiceActives.length > 0) {
                        let data = {
                            seller_id: receivable.sale_id,
                            discount: receivable.discount,
                            customer_id: receivable.id,
                            user_id: this.user.id,
                            due_date: moment().add(7, 'days').format('YYYY-MM-DD'),
                            details: receivable.invoices.filter(invoice => this.checkbox_id.includes(invoice.id))
                                .map(invoice => ({
                                    invoice_id: invoice.id,
                                    discount: 0,
                                    discount_status_id: 1
                                }))
                        }
                        receivables.push(data);
                    }
                })
                this.recursiveCreateBill(receivables, 0)
                // this.array = receivables;
                // this.$store.dispatch("Billing/createBilling", receivables).then(() => {
                //     this.$store.dispatch("Billing/setStatus", statusId).then(() => {
                //         this.$store.dispatch("Billing/setBillings").then(() => {
                //             this.$router.push("/accounting/billing/billings")
                //             this.hideLoadingModal();
                //         })
                //     })
                // })
            }
        },
        recursiveCreateBill(receivables, i) {
            this.$store.dispatch("Billing/createBilling", receivables[i]).then(() => {
                i = i + 1;
                this.msg = `กำลังบันทึกข้อมูล ${i} จาก ${receivables.length}`;
                if (receivables.length != i) {
                    this.recursiveCreateBill(receivables, i)
                } else {
                    this.hideLoadingModal();
                    this.$store.dispatch("Billing/setStatus", '').then(() => {
                        this.$store.dispatch("Billing/setBillings").then(() => {
                            this.$router.push("/accounting/billing/billings")
                            this.hideLoadingModal();
                        })
                    })
                }
            })
        },
        showPaymentModal() {
            return this.$store.dispatch("Payment/resetPaymentForm")
                .then(() => this.$store.dispatch("Payment/setPaymentLimit", this.activeOrder.total))
                .then(() => this.$refs.payment_modal.show())
        },
        hidePaymentModal() {
            this.$refs.payment_modal.hide()
        },
        submitPaymentModal(submitData) {
            if (submitData) {
                this.$store.dispatch("Payment/createPayment")
                    .then(() => this.$router.push("/accounting/billing/payments"))
            }
            this.hidePaymentModal()
        },
        getCustomerFromSale() {
            this.search.customer = null;
            if (this.canSaleOrdersAllView) {
                if (this.search.sale) {
                    let sale_id = this.search.sale.id;
                    this.$store.dispatch("Receivable/getCustomerFromSale", sale_id).then(res => {
                        this.optionCustomer = res;
                        // this.getReceivable();
                    });
                }
            } else {
                let sale_id = this.user.id;
                this.$store.dispatch("Receivable/getCustomerFromSale", sale_id).then(res => {
                    this.optionCustomer = res;
                    this.getReceivable();
                });
            }
        },
        getReceivablesPage() {
            this.msg = 'กำลังโหลดข้อมูล กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.receivables_checkbox_all = false;
            this.search.action = 'search';
            this.$store.dispatch("Receivable/setReceivables", {
                page: this.dataPaginate.current_page,
                search: this.search
            }).then(() => {
                this.hideLoadingModal();
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.select {
    border: 0;
}

table {
    tr {
        th {
            vertical-align: middle;
        }

        td, th {
            white-space: nowrap;
        }
    }
}

.select {
    border: 0;
}
</style>
